import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import "./payment.css";

/** Props of the payment modals (react-bootstrap) styled with the UI kit. */
export const secureModalProps = {
  backdrop: "static",
  keyboard: false,
  centered: true,
  dialogClassName: "ui-modal",
};

/** First step: the admin confirms their password. */
export const PasswordStep = ({
  title,
  email,
  password,
  onPasswordChange,
  wrongPassword,
  onCancel,
  onContinue,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          className="ui-form secure-form"
          onSubmit={(e) => {
            e.preventDefault();
            if (password.length >= 5) onContinue();
          }}
        >
          <p className="secure-intro">
            <i className="ri-lock-line" aria-hidden="true"></i>
            {t("To continue, please enter your password")}
          </p>
          <div className="ui-field ui-field-full">
            <label htmlFor="secure-email">{t("Email address")}</label>
            <input
              id="secure-email"
              className="ui-input"
              type="email"
              value={email || ""}
              disabled
            />
          </div>
          <div className="ui-field ui-field-full">
            <label htmlFor="secure-password">{t("Password")}</label>
            <input
              id="secure-password"
              className="ui-input"
              type="password"
              autoComplete="current-password"
              placeholder={t("Your password")}
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              autoFocus
            />
          </div>
          {wrongPassword && (
            <p className="secure-error" role="alert">
              <i className="ri-error-warning-line" aria-hidden="true"></i>
              {t("Wrong Password!")}
            </p>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="ui-btn ui-btn-secondary"
          onClick={onCancel}
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          className="ui-btn"
          disabled={password.length < 5}
          onClick={onContinue}
        >
          {t("Continue")}
        </button>
      </Modal.Footer>
    </>
  );
};

/** Secret value (API key…) hidden by default, with a show / hide button. */
export const SecretField = ({ id, label, value, onChange }) => {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);
  return (
    <div className="ui-field ui-field-full">
      <label htmlFor={id}>{label}</label>
      <div className="secure-secret">
        <input
          id={id}
          className="ui-input"
          type={shown ? "text" : "password"}
          autoComplete="off"
          spellCheck={false}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          className="ui-icon-btn"
          aria-label={shown ? t("Hide") : t("Show")}
          title={shown ? t("Hide") : t("Show")}
          onClick={() => setShown((current) => !current)}
        >
          <i
            className={shown ? "ri-eye-off-line" : "ri-eye-line"}
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>
  );
};

/** Last step: confirmation message. */
export const SuccessStep = ({ message, onDone }) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal.Body>
        <div className="secure-success">
          <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
          <p>{message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="ui-btn" onClick={onDone}>
          {t("Done")}
        </button>
      </Modal.Footer>
    </>
  );
};
